import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  list: null,
  error: null,
};

export default function BroadcastsNearest(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Broadcasts.Nearest.SET_LIST:
      return { ...state, list: action.data };
    case Action.Broadcasts.Nearest.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Broadcasts.Nearest.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Broadcasts.Nearest.CLEAR:
      return { ...state, list: null };
    default:
      return state;
  }
}
